import React, { FC } from 'react';

import { UniqueFlag } from 'views/OfferDesign/OfferDesign.types';

import Input from 'components/Input/Input';

import { Spacing, SPACING_MAP, TextFieldConfig } from '../FormFields.types';

import { useFormFieldsContext } from '../../../context';

const BASE_TEXT_FIELDS: TextFieldConfig[] = [
  { label: 'Name', name: 'name', placeholder: 'Name', uniqueFlag: 'isNameUnique' },
  { label: 'External ID', name: 'externalId', placeholder: 'External ID', uniqueFlag: 'isExternalIdUnique' }
];

interface IFormFieldsIdentitySectionProps {
  extraFields?: TextFieldConfig[];
  spacing?: Spacing;
}

export const FormFieldsIdentitySection: FC<IFormFieldsIdentitySectionProps> = ({
  extraFields = [],
  spacing = 'sm'
}): React.ReactElement => {
  const { values, getFieldProps, getFieldError } = useFormFieldsContext();
  const fields = [...BASE_TEXT_FIELDS, ...extraFields];

  return (
    <div className={`flex gap-5 ${SPACING_MAP[spacing]}`.trim()}>
      {fields.map(({ label, name, placeholder, defaultValue, maxLength, uniqueFlag }) => {
        const fieldProps = getFieldProps(name);
        const error = getFieldError(name, uniqueFlag as UniqueFlag | undefined);
        return (
          <Input
            key={name}
            label={label}
            isRequired
            name={name}
            placeholder={placeholder}
            value={String(values[name as keyof typeof values] ?? defaultValue ?? '')}
            onChange={fieldProps.onChange}
            onBlur={fieldProps.onBlur}
            state={error ? 'error' : 'default'}
            inputClassName={error ? 'border-base-destructive' : ''}
            description={error}
            maxLength={maxLength}
            className="flex-1"
          />
        );
      })}
    </div>
  );
};
